import { Link } from "react-router-dom";
import { MapPin, Stethoscope, ShieldCheck, ArrowRight, Info } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { HOSPITALS } from "@/data/content";

const SuiviMedical = () => (
  <div data-testid="suivi-medical-page">
    <PageHero
      eyebrow="Suivi médical"
      title="Des équipes hospitalières qui connaissent la maladie"
      description="La maladie de Waldmann étant très rare, être suivi par des équipes qui la connaissent change tout. Voici les services hospitaliers expérimentés dans sa prise en charge."
      testid="suivi-medical-title"
    />

    <section className="py-16 md:py-24">
      <div className="container-site">
        <div className="grid gap-8 lg:grid-cols-3">
          {HOSPITALS.map((h, i) => (
            <Reveal key={h.id} delay={i * 0.12}>
              <article data-testid={h.id} className="card-site group h-full overflow-hidden !p-0">
                <div className="relative overflow-hidden">
                  <img
                    src={h.image}
                    alt={`${h.name} — bâtiment hospitalier`}
                    className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                  <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-white/90 px-3 py-1.5 text-xs font-bold text-[#0F2C59] backdrop-blur-sm">
                    <MapPin size={13} className="text-[#FF6B6B]" /> {h.city}
                  </span>
                </div>
                <div className="p-7">
                  <h2 className="font-heading text-xl font-bold tracking-tight text-[#0F2C59]">{h.name}</h2>
                  <p className="mt-2 inline-flex items-center gap-2 text-sm font-bold text-[#0284C7]">
                    <Stethoscope size={15} /> {h.specialty}
                  </p>
                  <p className="mt-4 text-sm sm:text-base leading-relaxed text-slate-600">{h.description}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12">
          <div
            data-testid="privacy-note"
            className="flex items-start gap-4 rounded-2xl border-2 border-[#10B981]/30 bg-[#ECFDF5] p-5 sm:p-6"
          >
            <ShieldCheck size={26} className="mt-0.5 shrink-0 text-[#10B981]" aria-hidden="true" />
            <div>
              <h3 className="font-heading text-base font-bold text-[#065F46]">
                Respect de la confidentialité
              </h3>
              <p className="mt-1 text-sm sm:text-base leading-relaxed text-[#065F46]/90">
                Cette page ne présente que des informations publiques sur les services
                hospitaliers. Aucune donnée personnelle de patient n'est collectée, affichée ou
                partagée par l'association.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal className="mt-12">
          <div className="grid items-center gap-8 rounded-[2rem] bg-[#EFF6FF] p-8 sm:p-12 lg:grid-cols-[1.2fr_0.8fr]">
            <div>
              <span className="eyebrow">
                <Info size={15} /> Bon à savoir
              </span>
              <h2 className="mt-4 text-2xl sm:text-3xl font-bold tracking-tight text-[#0F2C59] leading-tight">
                Comment être orienté vers ces équipes ?
              </h2>
              <p className="mt-5 text-base leading-relaxed text-slate-600">
                C'est votre médecin traitant ou votre gastro-entérologue qui organise le lien avec
                ces services hospitaliers. L'association peut vous accompagner dans vos démarches :
                préparation du dossier, questions à poser, compréhension du parcours de soins.
                N'hésitez pas à nous solliciter.
              </p>
            </div>
            <div className="flex flex-col gap-4">
              <Link to="/contact" data-testid="suivi-contact-button" className="btn-don justify-center">
                Être accompagné(e) <ArrowRight size={17} />
              </Link>
              <Link to="/la-maladie" data-testid="suivi-maladie-button" className="btn-outline-navy justify-center">
                Comprendre la maladie
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  </div>
);

export default SuiviMedical;
